<div class="container">
    <header>
        <h1>Choose Your Subscription Plan</h1>
        <p class="subtitle">Select the plan that works best for you</p>
    </header>

    <div class="billing-cycle">
        <div class="cycle-option" id="monthlyOption">Monthly</div>
        <!--
        <div class="cycle-option selected" id="yearlyOption">Yearly <span class="save-badge">Save 20%</span></div>
        -->
    </div>

    <div class="cart-layout">
        <div class="subscription-options">
            <div class="subscription-tiers" *ngFor="let product of products(); let i = index">
                <!-- Basic Tier -->
                <div class="tier-card" [ngClass]="{ 'selected': products[i] === product }" data-tier="basic" data-price="9.99" data-yearly-price="95.90">
                    <h3 class="tier-name">Basic</h3>
                    <div class="tier-price">{{ ( product.amount / 100 ) | currency }} <span>/{{ product.interval }}</span></div>
                    <p class="tier-description">{{ product.description }}</p>
                    <ul class="feature-list">
                        <li *ngFor="let feature of product.features">{{ feature }}</li>
                    </ul>
                    <button class="select-button">{{ products[i] === product ? 'Selected' : 'Select Plan' }}</button>
                </div>

                <!-- Pro Tier
                <div class="tier-card selected popular" data-tier="pro" data-price="19.99" data-yearly-price="191.90">
                    <h3 class="tier-name">Pro</h3>
                    <div class="tier-price">$19.99 <span>/month</span></div>
                    <p class="tier-description">Ideal for professionals and small teams</p>
                    <ul class="feature-list">
                        <li>Access to all basic features</li>
                        <li>Up to 10 projects</li>
                        <li>10GB storage</li>
                        <li>Priority support</li>
                        <li>Advanced analytics</li>
                        <li class="not-included">Custom branding</li>
                    </ul>
                    <button class="select-button">Selected</button>
                </div>
                 -->

                <!-- Enterprise Tier 
                <div class="tier-card" data-tier="enterprise" data-price="49.99" data-yearly-price="479.90">
                    <h3 class="tier-name">Enterprise</h3>
                    <div class="tier-price">$49.99 <span>/month</span></div>
                    <p class="tier-description">For large teams with advanced needs</p>
                    <ul class="feature-list">
                        <li>Access to all features</li>
                        <li>Unlimited projects</li>
                        <li>100GB storage</li>
                        <li>24/7 priority support</li>
                        <li>Advanced analytics</li>
                        <li>Custom branding</li>
                    </ul>
                    <button class="select-button">Select Plan</button>
                </div>
                -->
            </div>
        </div>

        <div class="order-summary">
            <div class="summary-card">
                <h3 class="summary-title">Order Summary</h3>
                <div class="summary-item">
                    <div class="summary-item-label">Plan</div>
                    <div class="summary-item-value" id="selectedPlan">{{ selectedProduct()?.name }}</div>
                </div>
                <div class="summary-item">
                    <div class="summary-item-label">Billing Cycle</div>
                    <div class="summary-item-value" id="selectedCycle">{{ selectedProduct()?.interval }}</div>
                </div>
                <div class="summary-item">
                    <div class="summary-item-label">Subscription</div>
                    <div class="summary-item-value" id="subscriptionPrice">{{ ( selectedProduct()?.amount / 100 ) | currency }}</div>
                </div>
                <!--
                <div class="summary-item" id="discountRow">
                    <div class="summary-item-label">Yearly Discount</div>
                    <div class="summary-item-value" id="discountAmount">-$47.98</div>
                </div>
                -->
                <div class="summary-total">
                    <div>Total</div>
                    <div id="totalPrice">{{ ( selectedProduct()?.amount /100 ) | currency }}</div>
                </div>
                
            </div>

            <div class="summary-card">
               
                <h3 class="summary-title">Checkout</h3>
                 <!--
                <div class="payment-methods">
                    <div class="payment-method selected" data-method="credit-card">
                        <div class="payment-method-radio"></div>
                        <div class="payment-method-icon">VISA</div>
                        <div class="payment-method-details">
                            <div class="payment-method-name">Credit Card</div>
                            <div class="payment-method-description">Visa, Mastercard, Amex, Discover</div>
                        </div>
                    </div>
                    <div class="payment-method" data-method="paypal">
                        <div class="payment-method-radio"></div>
                        <div class="payment-method-icon">PP</div>
                        <div class="payment-method-details">
                            <div class="payment-method-name">PayPal</div>
                            <div class="payment-method-description">Pay with your PayPal account</div>
                        </div>
                    </div>
                    <div class="payment-method" data-method="apple-pay">
                        <div class="payment-method-radio"></div>
                        <div class="payment-method-icon">AP</div>
                        <div class="payment-method-details">
                            <div class="payment-method-name">Apple Pay</div>
                            <div class="payment-method-description">Pay with Apple Pay</div>
                        </div>
                    </div>
                </div>
                -->

                <button class="checkout-button" [disabled]="!selectedProduct()" (click)="goToCheckout()">Proceed to Checkout</button>
                <div class="secure-checkout">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <span>Secure Checkout</span>
                </div>
            </div>
        </div>
    </div>

    <div class="guarantee">
        <p><strong>30-Day Money-Back Guarantee</strong> - If you're not satisfied, we'll refund your payment within the first 30 days.</p>
    </div>
</div>